// Store listings for the Codeteki mobile app — one place, so every badge / QR
// on the site links to the same URLs. The QR SVGs in ../assets/qr are static
// renders of these two URLs: regenerate them if either ever changes.
export const APP_STORE_URL = "https://apps.apple.com/app/codeteki/id6812585272";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=au.codeteki.app";
